import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import type { PdfReportParams } from '~/_shared/constants/routes';
import { parseMapId } from '~/map/page/mapPage.helpers';
import { ReportPageComponent } from '~/report/page/reportPage.component';
import { errorPageSetError } from '~/store/errorPage/errorPage.actionCreators';
import { ErrorPageType } from '~/store/errorPage/errorPage.state';
import { mapChange } from '~/store/map/map.actionCreators';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';

export const ReportPageContainer = () => {
  const { mapId: routeMapIdString } = useParams<Partial<PdfReportParams>>();
  const dispatch = useDispatch();
  const reduxMapId = useMapIdSelector();
  const routeMapId = parseMapId(routeMapIdString);
  const mapIdIsInvalid = routeMapId === null;
  const mapId = routeMapId;

  useEffect(() => {
    if ((reduxMapId !== null && reduxMapId === routeMapId)) {
      return;
    }

    if (mapIdIsInvalid) {
      dispatch(errorPageSetError(ErrorPageType.MapNotFound));
      return;
    }

    dispatch(mapChange(routeMapId));
  }, [dispatch, mapIdIsInvalid, reduxMapId, routeMapId]);

  if (mapId === null) {
    return null;
  }

  return (
    <ReportPageComponent mapId={mapId} />
  );
};
